export const BASE_URL = (globalThis as any)?.location?.origin
export const authToken = process.env.STRAPI_AUTH_TOKEN
export const PAYPAL_CLIENT_ID = process.env.PAYPAL_CLIENT_ID ?? ''
export const PAYPAL_CLIENT_SECRET = process.env.PAYPAL_CLIENT_SECRET ?? ''
export const DIGITAL_OCEAN_API = process.env.DIGITAL_OCEAN_API ?? ''
